var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled from 'styled-components';
import { SACardContainer, SACardContent } from './card.variant.shared';
var Header = styled.header(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ",
    ";\n"])), function (props) {
    var theme = props.theme;
    return "\n      align-items: flex-end;\n      background: transparent;\n      display: flex;\n      height: 50px;\n      justify-content: space-between;\n      padding: 0 " + (theme === null || theme === void 0 ? void 0 : theme.size.spacer.large) + ";\n    ";
});
var Title = styled.h2(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ",
    ";\n"])), function (props) {
    var theme = props.theme;
    return "\n      color: " + (theme === null || theme === void 0 ? void 0 : theme.color.container.foreground) + ";\n      font-size: " + (theme === null || theme === void 0 ? void 0 : theme.font.primary.size.mediumTEMP) + ";\n      font-weight: " + (theme === null || theme === void 0 ? void 0 : theme.font.primary.weight.bold) + ";\n      margin: 0;\n      padding: 0;\n    ";
});
var HeaderButton = styled.button(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ",
    ";\n"])), function (props) {
    var theme = props.theme;
    return "\n      background-color: transparent;\n      border: none;\n      cursor: pointer;\n      color: " + (theme === null || theme === void 0 ? void 0 : theme.color.secondary.background) + ";\n      font-size: " + (theme === null || theme === void 0 ? void 0 : theme.font.primary.size.small) + ";\n      font-weight: " + (theme === null || theme === void 0 ? void 0 : theme.font.primary.weight.bold) + ";\n      margin: 0;\n      padding: " + (theme === null || theme === void 0 ? void 0 : theme.size.spacer.xs) + " 0;\n      text-transform: uppercase;\n    ";
});
export function SACardVariantSimple(_a) {
    var actionLabel = _a.actionLabel, actionLabelClickHandler = _a.actionLabelClickHandler, children = _a.children, height = _a.height, removePadding = _a.removePadding, title = _a.title, width = _a.width, rest = __rest(_a, ["actionLabel", "actionLabelClickHandler", "children", "height", "removePadding", "title", "width"]);
    var header;
    if (title && !actionLabel) {
        header = (React.createElement(Header, null,
            React.createElement(Title, null, title)));
    }
    else if (title && actionLabel) {
        var button = actionLabelClickHandler ? (React.createElement(HeaderButton, { type: "button", onClick: function (e) { return actionLabelClickHandler(e); } }, actionLabel)) : (React.createElement(HeaderButton, { type: "button" }, actionLabel));
        header = (React.createElement(Header, null,
            React.createElement(Title, null, title),
            button));
    }
    else {
        header = React.createElement(Header, null);
    }
    return (React.createElement(SACardContainer, __assign({ height: height, width: width }, rest),
        header,
        React.createElement(SACardContent, { removePadding: removePadding }, children)));
}
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=card.variant.simple.component.js.map